module.exports = __webpack_public_path__ + "img/base_nature_vallee_gorge.5046adae.svg";